'use strict';

wbApp.controller('HomeCtrl', ['$http', '$scope', '$timeout', 'tenantSettingSvc', 'securitySvc', 'activeFeaturesSvc',
function ($http, $scope, $timeout, tenantSettingSvc, securitySvc, activeFeaturesSvc) {

    $scope.tenantSetting = tenantSettingSvc.settings;
    $scope.tenantInfo = tenantInfo; // External dependency
    $scope.pages = _.take(actions, 25); // External dependency
    $scope.selectedPage = $scope.pages[0];
    for (var i = 0; i < $scope.pages.length; i++) {
        if (i === 0 && $scope.tenantSetting.showQuickNavOnHomePage) {
            $scope.pages[i].url = 'home/pages/home-page.html';
        } else {
            $scope.pages[i].url = 'home/pages/action-page.html';
        }
    }

    $scope.templateUrl = $scope.selectedPage.url;

    $scope.activitiesHref = hasStudentOnAction ? 'MyActivities' : 'Activities';
    $scope.shouldShowActivitiesBtn = $scope.tenantSetting.enableKindergartenSupport;
    $scope.shouldShowExcusesAndCompBtn = $scope.tenantSetting.enableClientUserSchedules && (
        !$scope.tenantSetting.disableClientCalendar &&
        ($scope.tenantSetting.allowClientCourseRegistration || securitySvc.isAuthenticated()));
    $scope.shouldShowCoursesBtn =
        $scope.tenantSetting.allowClientCourseRegistration ||
        $scope.tenantSetting.coursePreviewOnlyRegistration ||
        $scope.tenantSetting.courseInterestsSupport;
    $scope.shouldShowActionsBtn =
        ($scope.tenantSetting.allowClientActionRegistration) && $scope.pages.length > 1;
    $scope.shouldShowReservationBtn = $scope.tenantSetting.enableReservationSupport;
    $scope.shouldShowRentsBtn = $scope.tenantSetting.enableRentSupport;

    $scope.shouldShowFormsBtn = activeFeaturesSvc.isClientFormSupportEnabled(function (enabled) {
       
        $scope.shouldShowFormsBtn = enabled;

        var numberOfQuickButtons = ($scope.shouldShowCoursesBtn ? 1 : 0) +
            ($scope.shouldShowActionsBtn ? 1 : 0) +
            ($scope.shouldShowExcusesAndCompBtn ? 1 : 0) +
            ($scope.shouldShowActivitiesBtn ? 1 : 0) +
            ($scope.shouldShowReservationBtn ? 1 : 0) +
            ($scope.shouldShowFormsBtn ? 1 : 0) +
            ($scope.shouldShowRentsBtn ? 1 : 0);

        $scope.compressQuickButtons = numberOfQuickButtons > 6;
    });
    

    


    $scope.employeesSrc = employees; // External dependency
    $scope.employees = [];
    $scope.lastEmplIdx = 0;

    $scope.removeEmployees = function () {
        $scope.employees.length = 0;
    }

    $scope.selectEmployees = function () {
        if ($scope.employeesSrc.length > 0) {
            var idx1 = ($scope.lastEmplIdx + 1) % $scope.employeesSrc.length;
            var idx2 = ($scope.lastEmplIdx + 2) % $scope.employeesSrc.length;

            $scope.lastEmplIdx = idx2;

            $scope.employees.push($scope.employeesSrc[idx1]);

            if (idx1 !== idx2) {
                $scope.employees.push($scope.employeesSrc[idx2]);
            }
        }
    }

    $scope.selectEmployees();
    $scope.backwards = false;

    $scope.selectPage = function (page) {
        if ($scope.selectedPage === page) {
            return;
        }

        $scope.backwards = $scope.selectedPage.index > page.index;
        $scope.selectedPage = page;
        if (page.index !== 0 && $scope.templateUrl === 'home/pages/action-page.html') {
            $scope.templateUrl = 'home/pages/action-page-alt.html';
        } else {
            $scope.templateUrl = $scope.selectedPage.url;
        }
    }

    $scope.nextPage = function () {
        if ($scope.pages.length > ($scope.selectedPage.index + 1)) {
            $scope.selectPage($scope.pages[$scope.selectedPage.index + 1]);
        }
    }

    $scope.prevPage = function () {
        if ($scope.selectedPage.index > 0) {
            $scope.selectPage($scope.pages[$scope.selectedPage.index - 1]);
        }
    }

    $scope.cyclePage = function () {
        if ($scope.pages.length > ($scope.selectedPage.index + 1)) {
            $scope.selectPage($scope.pages[$scope.selectedPage.index + 1]);
        } else {
            $scope.selectPage($scope.pages[0]);
        }
    }

    $scope.isJPEG = function (url) {
        var lowerUrl = url.toLowerCase();
        return lowerUrl.endsWith('.jpg') || lowerUrl.endsWith('.jpeg');
    }

    $scope.onRegisterClick = function(page) {
        if (page.index === 0) {
            window.location = "/Courses";
        } else {
            window.location = "/Actions/Register/" + page.actionID + "?returnUrl=Actions";
        }
    }

    setInterval(function () {
        $scope.$apply(function () {
            $scope.cyclePage();
        })
    }, 15000);

    setInterval(function () {
        $scope.$apply(function () {
            $scope.removeEmployees();

            $timeout(function () {
                $scope.selectEmployees();
            },1000);
        })
    }, 5000);
}]);